import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ReviewsPage = () => {
  const reviews = [
    {
      name: 'Michael Rodriguez',
      rating: 5,
      date: 'November 2024',
      text: 'Exceptional service! Tony and his team went above and beyond to diagnose and fix my transmission issue. They were honest about the costs upfront and completed the work faster than expected. The 3-year warranty gives me great peace of mind. Highly recommend Sagil Service!',
      service: 'Transmission Repair'
    },
    {
      name: 'Sarah Thompson',
      rating: 5,
      date: 'October 2024',
      text: 'I\'ve been bringing my car to Sagil Service for over 5 years now, and Tony has never let me down. His expertise and honesty are unmatched in the area. They always explain what needs to be done and why, never pushing unnecessary services. Best auto shop in Passaic!',
      service: 'Regular Maintenance'
    },
    {
      name: 'James Patterson',
      rating: 5,
      date: 'October 2024',
      text: 'Tony Ligas is a true professional with incredible knowledge. My car was making a strange noise and other shops couldn\'t figure it out. Tony diagnosed it immediately and had it fixed the same day. Fair pricing and excellent work. This is now my go-to shop!',
      service: 'Engine Diagnostics'
    },
    {
      name: 'Maria Gonzalez',
      rating: 5,
      date: 'September 2024',
      text: 'Outstanding experience from start to finish! The team at Sagil Service is friendly, professional, and truly cares about their customers. They fixed my brake system and did a thorough inspection. I feel so much safer on the road now. Thank you, Tony!',
      service: 'Brake Repair'
    },
    {
      name: 'David Chen',
      rating: 5,
      date: 'September 2024',
      text: 'After 37 years in business, Tony knows everything about cars! He saved me thousands by properly diagnosing my issue instead of replacing parts I didn\'t need. Honest, reliable, and skilled - you can\'t ask for more. Sagil Service has earned a customer for life!',
      service: 'Engine Repair'
    },
    {
      name: 'Jennifer Williams',
      rating: 5,
      date: 'August 2024',
      text: 'I was stranded with a dead battery and called Sagil Service. They came to help me right away! Tony tested my charging system and replaced the alternator. The service was fast, professional, and reasonably priced. So grateful for their help!',
      service: 'Alternator Replacement'
    },
    {
      name: 'Robert Martinez',
      rating: 5,
      date: 'August 2024',
      text: 'Tony and his team are the best! They handled my AC repair quickly and efficiently. The shop is clean, the staff is friendly, and the prices are fair. It\'s rare to find such honest mechanics these days. Sagil Service is a gem in Passaic!',
      service: 'AC Repair'
    },
    {
      name: 'Lisa Anderson',
      rating: 5,
      date: 'July 2024',
      text: 'Excellent service and great communication! Tony explained everything in detail and showed me exactly what needed to be fixed. No surprises, no hidden fees. The work was done perfectly and my car runs like new. Highly recommend to everyone!',
      service: 'Suspension Repair'
    },
    {
      name: 'Thomas Brown',
      rating: 5,
      date: 'July 2024',
      text: 'I\'ve been to many mechanics over the years, but Tony at Sagil Service is by far the best. His 37 years of experience really shows in the quality of work. He fixed my check engine light issue that three other shops couldn\'t solve. True expert!',
      service: 'Diagnostics'
    },
    {
      name: 'Amanda Foster',
      rating: 5,
      date: 'June 2024',
      text: 'Sagil Service is my family\'s trusted auto shop. Tony has been taking care of our vehicles for years with honesty and integrity. He treats every customer like family and always goes the extra mile. We wouldn\'t trust anyone else with our cars!',
      service: 'Multiple Services'
    },
    {
      name: 'Carlos Rivera',
      rating: 5,
      date: 'June 2024',
      text: 'Tony is a master mechanic! He diagnosed and repaired my transmission problem at a fraction of what the dealer quoted. The work is guaranteed with a 3-year warranty. Professional, honest, and skilled - everything you want in a mechanic!',
      service: 'Transmission Service'
    },
    {
      name: 'Emily Johnson',
      rating: 5,
      date: 'May 2024',
      text: 'Best auto repair experience I\'ve ever had! Tony and his team are knowledgeable, courteous, and efficient. They completed my oil change and inspection quickly while I waited. The shop is clean and well-organized. Will definitely be back!',
      service: 'Oil Change & Inspection'
    },
    {
      name: 'Kevin Walsh',
      rating: 5,
      date: 'May 2024',
      text: 'Tony\'s expertise and dedication to quality service is evident in everything he does. He repaired my cooling system and prevented what could have been major engine damage. Fair prices, excellent work, and genuine care for customers. Highly recommended!',
      service: 'Cooling System Repair'
    },
    {
      name: 'Patricia Moore',
      rating: 5,
      date: 'April 2024',
      text: 'I can\'t say enough good things about Sagil Service! Tony is honest, reliable, and truly cares about keeping our community safe on the roads. He fixed my steering issue promptly and thoroughly. This is the kind of service that keeps customers coming back!',
      service: 'Steering Repair'
    },
    {
      name: 'Daniel Kim',
      rating: 5,
      date: 'April 2024',
      text: 'After 37 years in the business, Tony has seen it all! His experience and knowledge are invaluable. He diagnosed my electrical problem quickly and fixed it right the first time. Great communication, fair pricing, and quality work. Five stars all the way!',
      service: 'Electrical Repair'
    }
  ];

  const renderStars = (rating: number) => {
    return (
      <div className="flex items-center gap-1">
        {[...Array(5)].map((_, index) => (
          <i 
            key={index} 
            className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400 text-xl`}
          ></i>
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat h-96 flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/d1c7a5a83a3e09b86b1102f5ddbcdd7f.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-white">
            <nav className="text-sm mb-4">
              <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">Home</Link>
              <span className="mx-2 text-gray-400">/</span>
              <span className="text-white">Reviews</span>
            </nav>
            <h1 className="text-5xl font-bold">Customer Reviews</h1>
            <p className="text-xl mt-4">See what our satisfied customers have to say</p>
          </div>
        </div>
      </section>

      {/* Reviews Stats */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="text-5xl font-bold text-red-700 mb-2">4.5</div>
              <div className="flex justify-center mb-2">
                {renderStars(5)}
              </div>
              <p className="text-gray-600">Average Rating</p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="text-5xl font-bold text-red-700 mb-2">500+</div>
              <i className="ri-chat-smile-3-line text-4xl text-red-700 mb-2"></i>
              <p className="text-gray-600">Happy Customers</p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <div className="text-5xl font-bold text-red-700 mb-2">37</div>
              <i className="ri-time-line text-4xl text-red-700 mb-2"></i>
              <p className="text-gray-600">Years in Business</p>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Customers Say</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              These are real 5-star reviews from our valued customers. We're proud to serve the Passaic community 
              with honest, reliable auto repair services.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-shadow">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-red-700 rounded-full flex items-center justify-center mr-3">
                      <span className="text-white font-bold text-lg">
                        {review.name.split(' ').map(n => n[0]).join('')}
                      </span>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">{review.name}</h3>
                      <p className="text-sm text-gray-500">{review.date}</p>
                    </div>
                  </div>
                </div>
                
                <div className="mb-3">
                  {renderStars(review.rating)}
                </div>
                
                <p className="text-gray-700 mb-4 leading-relaxed">{review.text}</p>
                
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-sm text-gray-600">
                    <i className="ri-tools-line mr-1"></i>
                    <strong>Service:</strong> {review.service}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Google Reviews Link */}
          <div className="mt-12 text-center">
            <div className="bg-gray-50 rounded-lg p-8 inline-block">
              <i className="ri-google-fill text-6xl text-red-700 mb-4"></i>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">See More Reviews on Google</h3>
              <p className="text-gray-700 mb-6">Visit our Google Business Profile to read more reviews and leave your own!</p>
              <a 
                href="https://www.google.com/search?q=sagil+service+passaic+nj"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-3 bg-red-700 hover:bg-red-600 text-white rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line mr-2"></i>
                View on Google
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Experience Our 5-Star Service</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join hundreds of satisfied customers who trust Sagil Service for all their automotive needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>
              Schedule Service
            </Link>
            <a 
              href="tel:(973) 472-0890" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (973) 472-0890
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReviewsPage;
